import { Box } from '@mui/material'
import { ChevronRight16Regular } from '@/components/Icon'
import Pressable from '@/theme/Pressable'
import styles from './thoughtchain.module.scss'

export default function ThoughtRail({
  icon: Icon,
  expanded,
  onToggle,
  showConnector = true,
}) {
  return (
    <Box className={styles.railColumn}>
      <Pressable
        aria-expanded={expanded}
        onClick={onToggle}
        className={styles.railToggle}
      >
        <Box className={styles.railIconSlot}>
          <Icon className={styles.activityIcon} fontSize={20} />
          <ChevronRight16Regular
            className={`${styles.chevronIcon} ${expanded ? styles.chevronExpanded : ''}`}
            fontSize={18}
          />
        </Box>
      </Pressable>
      {showConnector ? <Box className={styles.connector} aria-hidden /> : null}
    </Box>
  )
}
